import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalShell({ title, kicker, updated, children, testid }) {
  return (
    <div className="min-h-screen" style={{ background: "var(--ek-page)" }} data-testid={testid}>
      <header className="border-b sticky top-0 z-20" style={{ background: "rgba(7,11,20,0.9)", backdropFilter: "blur(12px)", borderColor: "var(--ek-border)" }}>
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="legal-home-link">
            <img src="/ek-logo.png" alt="EvidenceKeeper" className="h-9 w-9 object-contain" />
            <span className="font-head font-bold tracking-tight">EvidenceKeeper</span>
          </Link>
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm transition-colors hover:text-slate-200" style={{ color: "var(--ek-text-muted)" }} data-testid="legal-back-link">
            <ArrowLeft className="h-4 w-4" /> Back
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <div className="ek-stamp inline-block mb-3">{kicker}</div>
        <h1 className="font-head font-bold text-4xl sm:text-5xl tracking-tight">{title}</h1>
        {updated && <p className="ek-mono-label mt-3">LAST UPDATED · {updated}</p>}
        <div className="mt-4 border rounded-md px-4 py-3 text-xs" style={{ borderColor: "rgba(245,158,11,0.3)", background: "rgba(245,158,11,0.06)", color: "var(--ek-text-secondary)" }}>
          This is a plain-language draft provided for convenience and app-store review. It is not legal advice — please have your counsel review and finalize before public release.
        </div>

        <article className="mt-10 space-y-8 text-sm leading-relaxed" style={{ color: "var(--ek-text-secondary)" }}>
          {children}
        </article>

        <footer className="mt-16 pt-8 border-t flex flex-wrap items-center gap-x-6 gap-y-2" style={{ borderColor: "var(--ek-border)" }}>
          <Link to="/privacy" className="ek-mono-label hover:text-slate-200" data-testid="footer-privacy-link">PRIVACY</Link>
          <Link to="/terms" className="ek-mono-label hover:text-slate-200" data-testid="footer-terms-link">TERMS</Link>
          <Link to="/delete-account" className="ek-mono-label hover:text-slate-200" data-testid="footer-delete-link">DELETE ACCOUNT</Link>
          <span className="ek-mono-label ml-auto">HERRELL HOMESTEAD LLC</span>
        </footer>
      </main>
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section>
      <h2 className="font-head font-semibold text-lg tracking-tight mb-2" style={{ color: "var(--ek-text)" }}>{heading}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
